import axiosInstance from '@/utils/axiosInstance';
import { showAlert } from '@/components/common/toastify/ToastContainer';
import { handleApiError } from '@/lib/handleApiError';

// Create a class
export const createClass = async (classData) => {
  try {
    const res = await axiosInstance.post('/SmartProAPI/api/classes', classData);
    showAlert('success', 'Class created successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

// Get all classes
export const getClasses = async () => {
  try {
    const res = await axiosInstance.get('/SmartProAPI/api/classes');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

// Update a class
export const updateClass = async (id, classData) => {
  try {
    const res = await axiosInstance.put(
      `/SmartProAPI/api/classes/${id}`,
      classData,
    );
    showAlert('success', 'Class updated successfully');
    return res.data;
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};

// Delete a class
export const deleteClass = async (id) => {
  try {
    await axiosInstance.delete(`/SmartProAPI/api/classes/${id}`);
    showAlert('success', 'Class deleted successfully');
  } catch (error) {
    handleApiError(
      'error',
      error?.response?.data?.message,
      error?.response?.status,
    );
    throw error;
  }
};
